import { render, staticRenderFns } from "./Notifications.container.vue?vue&type=template&id=372a0a80&"
import script from "./Notifications.container.vue?vue&type=script&lang=ts&"
export * from "./Notifications.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports